<template>
    <div style="
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background-color: white;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        padding: 100px 20px 20px;
    ">
            <span style="min-width: 35px; max-width: 35px; width: 35px; height: 35px; display: flex; align-items: center; justify-content: center; color: #212B36; background-color: #F2F2F2; border-radius: 100%; position: absolute; left: 16px; top: 35px;
            " @click="hideDeliveryDetails"><i class="fal fa-arrow-left"></i></span>
            <h4 style="
            font-size: 26px;
                line-height: 34px;
                color: #000;
                letter-spacing: 0.31px;
                font-weight: 500;
                margin-bottom: 5px;
            ">{{ defaultCartLanguage.add_delivery_details }}</h4>
            <template v-if="cart && cart.length">
                <hr>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_name" v-model="localAddress.name">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_phone" v-model="localAddress.phone">
                        </div>
                    </div>
                    <div class="col-12" v-if="emailMandatoryOnOrder">
                        <input type="hidden" class="form-control" :placeholder="defaultCartLanguage.delivery_details_email" v-model="localAddress.email">
                    </div>
                    <div class="col-12" v-else>
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_email" v-model="localAddress.email">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_street" v-model="localAddress.street">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_city" v-model="localAddress.city">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_zip" v-model="localAddress.zip">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_province" v-model="localAddress.province">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <input type="text" class="form-control" :placeholder="defaultCartLanguage.delivery_details_country" v-model="localAddress.country">
                        </div>
                    </div>
                </div>
                <br>
                <template v-if="canShowNoteForm">
                    <div v-if="showNoteForm">
                        <div class="form-group">
                            <textarea class="form-control" v-model="formNote" :placeholder="defaultCartLanguage.add_note_placeholder"></textarea>
                        </div>
                        <button style="display: flex; justify-content: center; align-items: center; font-weight: bold; width: calc(100vw - 40px); height: 40px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click.prevent="setCartNote(formNote); showNoteForm = false; formNote = ''">{{defaultCartLanguage.save_note_button }}</button>
                    </div>
                    <div v-else-if="!showNoteForm && cartNote">
                        <p>{{ cartNote }}</p>
                        <button style="display: flex; justify-content: center; align-items: center; width: calc(100vw - 40px); height: 46px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click="formNote = cartNote; showNoteForm = true">{{ defaultCartLanguage.edit_note_button }}</button>
                    </div>
                    <div v-else>
                        <button style="display: flex; justify-content: center; align-items: center; width: calc(100vw - 40px); height: 46px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click="showNoteForm = true">{{ defaultCartLanguage.add_note_button }}</button>
                    </div>
                </template>
                <div style="position: absolute; bottom: 20px; right: 20px; left: 20px;">
                    <div class="row">
                        <div class="col-4">{{ defaultCartLanguage.total }}</div>
                        <div class="col-4"></div>
                        <div class="col-4 text-right">€{{ (cartFullTotal).toFixed(2) }}</div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-12">
                            <input type="checkbox" name="terms-accepted" v-model="termsAccepted"> {{ defaultCartLanguage.terms_pt1 }} <a :href="termsLink" target="_blank">{{ defaultCartLanguage.terms_pt2 }}</a>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px" v-if="deliveryDetailsAreComplete && amountIsValid">
                        <div class="col-12"><button class="text-center btn btn-block" @click.prevent="sendOrder(true)">{{ defaultCartLanguage.send_order_button }}</button></div>
                    </div>
                    <div class="row" style="margin-top: 20px" v-else>
                        <div class="col-12" v-if="!amountIsValid" style="color: red; text-align: center;">{{ defaultCartLanguage.minimum_order_is }} €{{ parseFloat(minimumOrder).toFixed(2) }}</div>
                        <div class="col-12"><button class="text-center btn btn-block" style='background-color: #EDEDED!important; color: #908c8c!important'>{{ defaultCartLanguage.send_order_button }}</button></div>
                    </div>
                </div>
            </template>
            <div v-else><span><small><em>{{ defaultCartLanguage.cart_is_empty }}</em></small></span></div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
export default {
    data() {
        return  {
            canShowNoteForm: false,
            showNoteForm: false,
            termsAccepted: false,
            formNote: '',
            localAddress: {
                name: null,
                phone: null,
                email: null,
                street: null,
                city: null,
                zip: null,
                province: null,
                country: null,
            },
        }
    },

    props: [
        'findValueFromCode', 'language', 'defaultLanguage', 'isShop', 'charges'
    ],

    mounted () {
        this.localAddress = this.deliveryDetails;
        this.localAddress.email = this.cartEmail;
    },

    computed: {
        ...mapGetters(['cart', 'cartRestaurant', 'cartTotal', 'cartNote', 'previewableCartItem', 'defaultCartLanguage', 'deliveryDetails', 'termsLink', 'emailMandatoryOnOrder', 'cartEmail', 'minimumOrder']),
        deliveryDetailsAreComplete () {
            return Object.keys(this.localAddress).every(k => (this.localAddress[k] !== null) && (this.localAddress[k].length > 1)) && this.termsAccepted
        },

        cartFullTotal() {
            let feeCharge = 0;
            if ((this.cartRestaurant && (this.cartRestaurant.business_model == 'room_service' || this.cartRestaurant.business_model == 'delivery')) || this.isShop) {
                feeCharge += (this.charges.room_service_fee_type == 'percentage' ? this.cartTotal * this.charges.room_service_fee_charge / 10000 : this.charges.room_service_fee_charge / 100);    
            }
            if ((this.cartRestaurant && this.cartRestaurant.business_model == 'delivery') || this.isShop) {
                feeCharge += (this.charges.delivery_fee_type == 'percentage' ? this.cartTotal * this.charges.delivery_fee_charge / 10000 : this.charges.delivery_fee_charge / 100);
            }
            return this.cartTotal + feeCharge;
        },

        amountIsValid() {
            return this.cartTotal >= this.minimumOrder
        }
    },

    methods: {
        ...mapActions(['closeCart', 'setPreviewableCartItem', 'setCartNote', 'sendOrder', 'hideDeliveryDetails', 'setDeliveryDetails'])
    }
}
</script>
